import type { LangCode } from '@/lib/i18n/lang';

/** BCP 47 locales for dates — sr uses Latin script to avoid Cyrillic month names in UI. */
const DATE_LOCALE: Record<LangCode, string> = {
  sr: 'sr-Latn-RS',
  'sr-cyrl': 'sr-Cyrl-RS',
  en: 'en-GB',
  de: 'de-DE',
  ru: 'ru-RU',
  tr: 'tr-TR',
};

export function dateLocaleForLang(lang: LangCode): string {
  return DATE_LOCALE[lang] ?? 'en-GB';
}

export function formatDate(
  input: Date | string | null | undefined,
  lang: LangCode,
  options: Intl.DateTimeFormatOptions,
): string {
  if (input == null) return '';
  const d = typeof input === 'string' ? new Date(input) : input;
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleDateString(dateLocaleForLang(lang), options);
}
